module.exports = __webpack_public_path__ + "static/img/AdvancedTorsoDesign.71d99617.jpg";